// Centralized site content — easily editable, no duplication across files.

export const COMPANY = {
  name: "GEMA",
  fullName: "GESTIÓN ESPECIALIZADA MANTENIMIENTOS & SUMINISTROS S.A.S.",
  tagline: "Automotriz · Industrial · Naval",
  description:
    "Empresa colombiana especializada en mantenimiento automotriz, industrial y naval, con soluciones técnicas integrales, suministro de repuestos y servicios especializados de alta confiabilidad.",
  phone: "304 560 3960",
  phoneRaw: "+573045603960",
  whatsapp: "https://wa.me/573045603960",
  email: "Mantenimientosysuministrosgema@gmail.com",
  address: "Turbaco – Bolívar, Colombia",
  addressLong: "Troncal de Occidente, Portería Urb. Terrazas de Cucuman, Turbaco – Bolívar, Colombia",
  hours: [
    { day: "Lunes – Viernes", time: "8:00 a.m. – 6:00 p.m." },
    { day: "Sábado", time: "8:00 a.m. – 1:00 p.m." },
    { day: "Domingo", time: "Cerrado" },
  ],
  social: [
    { name: "Facebook", icon: "Facebook", url: "#" },
    { name: "Instagram", icon: "Instagram", url: "#" },
    { name: "LinkedIn", icon: "Linkedin", url: "#" },
  ],
};

export const NAV = [
  { label: "Inicio", to: "/" },
  { label: "Servicios", to: "/servicios" },
  { label: "Nosotros", to: "/nosotros" },
  { label: "Blog", to: "/blog" },
  { label: "Contacto", to: "/contacto" },
];

export const STRENGTHS = [
  {
    icon: "Layers",
    title: "Experiencia Multisectorial",
    text: "Proyectos automotrices, industriales y navales con soluciones adaptadas a cada sector y necesidad.",
    stat: 3,
    statSuffix: "",
    statLabel: "Sectores atendidos",
  },
  {
    icon: "BadgeCheck",
    title: "Repuestos Certificados",
    text: "Repuestos y componentes de calidad para garantizar el óptimo desempeño y una mayor vida útil de los equipos.",
    stat: 100,
    statSuffix: "%",
    statLabel: "Componentes verificados",
  },
  {
    icon: "ShieldCheck",
    title: "Calidad Garantizada",
    text: "Procesos técnicos orientados a resultados confiables, seguros y alineados con altos estándares de servicio.",
    stat: 24,
    statSuffix: "/7",
    statLabel: "Compromiso operativo",
  },
  {
    icon: "Headset",
    title: "Soporte Técnico",
    text: "Asesoría especializada y acompañamiento en cada etapa del servicio para soluciones eficientes y duraderas.",
    stat: 360,
    statSuffix: "°",
    statLabel: "Acompañamiento integral",
  },
];

export const SERVICES = [
  {
    slug: "automotriz",
    icon: "Car",
    name: "Automotriz",
    tagline: "Mantenimiento y diagnóstico de vehículos",
    short:
      "Mantenimiento preventivo y correctivo, diagnóstico electrónico, programación automotriz, aire acondicionado, latonería, pintura, restauración y polichado.",
    image: "https://images.pexels.com/photos/15543138/pexels-photo-15543138.jpeg",
    intro:
      "Soluciones integrales para vehículos particulares y flotas corporativas. Combinamos diagnóstico especializado, tecnología de escaneo y personal calificado para asegurar el óptimo desempeño de cada vehículo.",
    items: [
      "Mantenimiento preventivo y correctivo",
      "Diagnóstico electrónico (escáner)",
      "Programación automotriz",
      "Aire acondicionado automotriz",
      "Cambio de aceite",
      "Latonería y pintura",
      "Restauración y polichado",
    ],
    benefits: [
      "Diagnóstico preciso que evita reparaciones innecesarias",
      "Menor tiempo de inmovilización del vehículo",
      "Repuestos de calidad para mayor durabilidad",
      "Atención tanto para particulares como para flotas",
    ],
    process: [
      { step: "Recepción y diagnóstico", desc: "Evaluación técnica y escaneo electrónico del vehículo." },
      { step: "Cotización clara", desc: "Presupuesto detallado y transparente antes de intervenir." },
      { step: "Ejecución del servicio", desc: "Trabajo realizado por personal calificado con repuestos certificados." },
      { step: "Entrega y garantía", desc: "Pruebas de funcionamiento y acompañamiento posterior." },
    ],
    faqs: [
      { q: "¿Atienden vehículos de flotas corporativas?", a: "Sí. Contamos con capacidad para atender tanto vehículos particulares como flotas de empresas privadas y entidades públicas." },
      { q: "¿Realizan programación de módulos electrónicos?", a: "Sí, ofrecemos programación automotriz y reconfiguración de módulos para restablecer el desempeño óptimo del vehículo." },
      { q: "¿Puedo solicitar una cotización sin compromiso?", a: "Por supuesto. Puede solicitar una cotización a través del formulario o por WhatsApp y le responderemos oportunamente." },
    ],
  },
  {
    slug: "industrial",
    icon: "Factory",
    name: "Industrial",
    tagline: "Mantenimiento de maquinaria y sistemas",
    short:
      "Mantenimiento de maquinaria industrial, sistemas eléctricos, motores eléctricos, bombas, compresores y soluciones técnicas para la industria.",
    image: "https://images.unsplash.com/photo-1738918901587-41f3f3f88afd",
    intro:
      "Servicios especializados para plantas e instalaciones industriales. Diseñamos planes de mantenimiento orientados a la continuidad operativa y a la reducción de paradas no programadas.",
    items: [
      "Mantenimiento de maquinaria industrial",
      "Sistemas eléctricos industriales",
      "Reparación de motores eléctricos",
      "Mantenimiento de bombas y compresores",
      "Equipos especializados",
      "Soluciones técnicas a la medida",
    ],
    benefits: [
      "Reducción de paradas no programadas",
      "Mayor vida útil de equipos y sistemas",
      "Planes de mantenimiento adaptados a cada planta",
      "Cumplimiento y trazabilidad en cada intervención",
    ],
    process: [
      { step: "Levantamiento técnico", desc: "Inspección de equipos y análisis de condiciones de operación." },
      { step: "Plan de intervención", desc: "Programación preventiva o correctiva según prioridades." },
      { step: "Ejecución especializada", desc: "Personal técnico y suministro de componentes adecuados." },
      { step: "Informe y seguimiento", desc: "Documentación del servicio y recomendaciones." },
    ],
    faqs: [
      { q: "¿Ofrecen planes de mantenimiento preventivo?", a: "Sí, diseñamos planes preventivos según horas de operación y condiciones específicas de cada equipo." },
      { q: "¿Trabajan con entidades públicas?", a: "Sí, apoyamos procesos comerciales y contractuales, incluyendo requerimientos institucionales." },
      { q: "¿Reparan motores eléctricos industriales?", a: "Contamos con servicios de reparación y mantenimiento de motores y sistemas eléctricos industriales." },
    ],
  },
  {
    slug: "naval",
    icon: "Ship",
    name: "Naval",
    tagline: "Servicios para embarcaciones y equipos marítimos",
    short:
      "Mantenimiento mecánico naval, sistemas eléctricos, soldadura, fibra de vidrio y servicios especializados para embarcaciones y equipos marítimos.",
    image: "https://images.unsplash.com/photo-1569875875269-6943dc3154c4",
    intro:
      "El entorno marino exige un mantenimiento riguroso. Ofrecemos servicios navales especializados que aseguran la confiabilidad y operatividad de motores, sistemas y estructuras.",
    items: [
      "Mecánica naval",
      "Sistemas eléctricos navales",
      "Soldadura naval",
      "Trabajos en fibra de vidrio",
      "Mantenimiento de motores marinos",
      "Servicios especializados marítimos",
    ],
    benefits: [
      "Soluciones diseñadas para el exigente entorno marino",
      "Continuidad operativa de embarcaciones",
      "Personal calificado en mecánica marina",
      "Componentes resistentes a condiciones marítimas",
    ],
    process: [
      { step: "Evaluación a bordo", desc: "Diagnóstico de motores, sistemas eléctricos y estructuras." },
      { step: "Definición del alcance", desc: "Planeación del servicio y suministro de repuestos." },
      { step: "Ejecución técnica", desc: "Mecánica, soldadura y fibra de vidrio con estándares de calidad." },
      { step: "Pruebas y entrega", desc: "Verificación operativa y recomendaciones de mantenimiento." },
    ],
    faqs: [
      { q: "¿Realizan trabajos de soldadura y fibra de vidrio?", a: "Sí, ofrecemos soldadura naval y trabajos en fibra de vidrio para embarcaciones y equipos marítimos." },
      { q: "¿Atienden motores marinos Cummins?", a: "Sí, brindamos mantenimiento y suministro de repuestos para motores, incluyendo la línea Cummins." },
      { q: "¿Prestan servicio a embarcaciones de distintos tamaños?", a: "Evaluamos cada proyecto para ofrecer una solución técnica adecuada a la embarcación y sus equipos." },
    ],
  },
  {
    slug: "suministros",
    icon: "PackageCheck",
    name: "Suministros",
    tagline: "Repuestos y componentes técnicos",
    short:
      "Comercialización de repuestos, componentes eléctricos, sistemas de refrigeración, repuestos industriales, navales y automotrices.",
    image: "https://images.unsplash.com/photo-1606577924006-27d39b132ae2",
    intro:
      "Suministro técnico oportuno y confiable. Proveemos repuestos y componentes de fabricantes reconocidos para garantizar el desempeño y la disponibilidad de sus equipos.",
    items: [
      "Repuestos automotrices",
      "Repuestos navales",
      "Repuestos industriales",
      "Componentes eléctricos",
      "Sistemas de refrigeración",
      "Suministros para motores Cummins",
    ],
    benefits: [
      "Suministro oportuno para minimizar tiempos muertos",
      "Componentes de fabricantes reconocidos",
      "Asesoría técnica en la selección de repuestos",
      "Soporte para proyectos de mayor escala",
    ],
    process: [
      { step: "Requerimiento técnico", desc: "Identificación precisa del componente necesario." },
      { step: "Cotización y disponibilidad", desc: "Propuesta clara con tiempos de entrega." },
      { step: "Suministro", desc: "Entrega de repuestos y componentes certificados." },
      { step: "Acompañamiento", desc: "Asesoría en instalación y uso cuando se requiere." },
    ],
    faqs: [
      { q: "¿Suministran repuestos para motores Cummins?", a: "Sí, contamos con suministro de repuestos y componentes para motores Cummins." },
      { q: "¿Realizan entregas a empresas?", a: "Sí, atendemos requerimientos de empresas privadas, industrias y entidades públicas." },
      { q: "¿Ofrecen asesoría en la selección de repuestos?", a: "Sí, brindamos asesoría técnica para garantizar la compatibilidad y el desempeño." },
    ],
  },
];

export const BRANDS = [
  "CUMMINS", "BOSCH", "CATERPILLAR", "PERKINS", "YANMAR",
  "VOLVO PENTA", "DETROIT DIESEL", "DANFOSS", "WEG", "SIEMENS", "ABB", "SKF",
];

export const TESTIMONIALS = [
  {
    quote:
      "El acompañamiento técnico de GEMA fue decisivo para mantener la operatividad de nuestros equipos. Cumplimiento y seriedad en cada etapa del servicio.",
    author: "Coordinación de Mantenimiento",
    role: "Empresa del sector industrial",
  },
  {
    quote:
      "Respuesta oportuna y repuestos confiables para nuestra flota. Un proveedor con capacidad técnica real y comunicación clara.",
    author: "Jefatura de Operaciones",
    role: "Flota corporativa",
  },
  {
    quote:
      "El mantenimiento naval se ejecutó con procedimientos organizados y estándares de calidad. Recomendamos su trabajo para proyectos exigentes.",
    author: "Gerencia de Proyectos",
    role: "Sector naval",
  },
];

export const VALUES = [
  { icon: "ShieldCheck", title: "Cumplimiento", text: "Honramos cada compromiso adquirido con responsabilidad y transparencia." },
  { icon: "Gauge", title: "Eficiencia", text: "Procesos organizados que optimizan tiempos y recursos." },
  { icon: "Award", title: "Calidad", text: "Altos estándares técnicos en cada servicio ejecutado." },
  { icon: "RefreshCw", title: "Mejora Continua", text: "Evolución permanente de nuestras capacidades y procesos." },
];
